export const SELECT_JOB_TYPE_FILTER = "SELECT_JOB_TYPE_FILTER";
export const DESELECT_JOB_TYPE_FILTER = "DESELECT_JOB_TYPE_FILTER";
export const SELECT_JOB_INDUSTRY_FILTER = "SELECT_JOB_INDUSTRY_FILTER";
export const DESELECT_JOB_INDUSTRY_FILTER = "DESELECT_JOB_INDUSTRY_FILTER";
export const SELECT_RADIUS_FILTER = "SELECT_RADIUS_FILTER";
export const SET_KEYWORD_SEARCH_FILTER = "SET_KEYWORD_SEARCH_FILTER";
export const SET_SALARY_FILTER = "SET_SALARY_FILTER";
export const SELECT_FLOAT_BUTTON = "SELECT_FLOAT_BUTTON";
export const RESET_JOB_FILTERS = "RESET_JOB_FILTERS";
export const RESET_SEARCH = "RESET_SEARCH";
export const SET_SHOW_RECENT_JOBS = "SET_SHOW_RECENT_JOBS";
export const FETCH_JOBS = "FETCH_JOBS";
export const FETCH_NEXT_JOBS = "FETCH_NEXT_JOBS";
export const FETCH_SPONSORED_JOBS = "FETCH_SPONSORED_JOBS";
export const FETCH_RECENT_JOBS = "FETCH_RECENT_JOBS";
export const FETCH_SIMILAR_FEATURED_JOBS = "FETCH_SIMILAR_FEATURED_JOBS";
export const FETCH_SIMILAR_SPONSORED_JOBS = "FETCH_SIMILAR_SPONSORED_JOBS";
export const SET_HR_MODE = "SET_HR_MODE";

export const DEFAULT_RADIUS = 15;

export const MIN_SALARY = 0;
export const ALL_SALARY = "all";

export const JOBS_FILTER_INITIAL_STATE = {
  type: [],
  industry: [],
  radius: DEFAULT_RADIUS,
  keyword: "",
  salary: {
    type: ALL_SALARY,
    min: MIN_SALARY,
    competitive: true,
  },
  selectedFloatButton: null,
};
